import "./firstdiv.css";
import IMAGES from "../../../images/images";
import { HashLink} from 'react-router-hash-link';
// import {Link} from 'react-scroll';


export default function FirstDiv() {
    return (
        <div className="firstDiv__wrapper" id="home">
            <div className="left">
                <div className="left__image">
                    <img src={IMAGES.omotolaPort} alt="" />
                </div>
                <div className="test">
                <HashLink smooth to="/#portfolio" className="home__downArrow">
                    <img src={IMAGES.downArrow} alt="" />
                </HashLink>
                </div>
            </div>
            <div className="right">
                <div className="wrapper">
                    <div className="wrapper__text">
                        <h1>Omotola Ogunsola</h1>
                        <h3>ARCHITECT, FULL STACK ENGINEER & PRODUCT DESIGNER</h3>
                    </div> 
                </div>
                
                <div className="home__navWrapper">
                    <div className="home__nav">
                        <HashLink className="home__nav1" activeClass="active" smooth to={"#home"}>
                            <span className=""></span>
                        </HashLink>
                        <HashLink className="home__nav1" activeClass="active" smooth to={"#portfolio"}>
                            <span className=""></span>
                        </HashLink>
                        <HashLink className="home__nav1" activeClass="active"  smooth to={"#footer"}>
                            <span className=""></span>
                        </HashLink>
                    </div>
                </div>
            </div>
        </div>
    )
    
}
